import Config from '@/config'

window.addEventListener('load', () => {
    let token = getToken();
    token && setToken(token);
});

export const setToken = (token) => {
    window.sessionStorage.setItem('token', token);
};

export const getToken = () => {
    const token = window.sessionStorage.getItem('token');
    return token ? token : false;
};

function weixinClose() {
    WeixinJSBridge.call('closeWindow');
}

export const wxClose = () => {
    if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', weixinClose, false);
        } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', weixinClose);
            document.attachEvent('onWeixinJSBridgeReady', weixinClose);
        }
    } else {
        weixinClose();
    }
};

export function formatDistance(distance) {
    if (!distance) {
        return '';
    }

    if (distance > 1000) {
        return Number(distance / 1000).toFixed(1) + 'km';
    } else {
        return Math.ceil(distance) + 'm';
    }
}

export function formatDuration(duration) {
    if (!duration || duration < 0) {
        return null;
    }
    if (duration <= 3600) {
        return Math.round(duration / 60) + '分钟';
    }
    if (duration > 3600) {
        return Math.round(duration / 3600) + '小时' + Math.round((duration % 3600) / 60) + '分';
    }
}

export function randomIntFromRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export const getWebsocketUrl = () => {
    let baseUrl = process.env.NODE_ENV === 'development' ? Config.baseUrl.dev : Config.baseUrl.pro;
    return baseUrl.replace('http', 'ws') + 'rtc/ws?clientType=h5&clientVersion='
        + Config.clientVersion + '&token=' + getToken();
};

function numberTo2Len(n) {
    const str = n.toString();
    return str[1] ? str : `0${str}`;
}

export function formatNumber(num) {
    if (num > 10000) {
        return Number(num / 10000).toFixed(0) + '万+';
    } else {
        return num;
    }
}

export function formatTime(date) {
    const year = date.getFullYear();
    const month = numberTo2Len(date.getMonth() + 1);
    const day = numberTo2Len(date.getDate());

    const hour = numberTo2Len(date.getHours());
    const minute = numberTo2Len(date.getMinutes());
    const second = numberTo2Len(date.getSeconds());

    const t1 = [year, month, day].map(formatNumber).join('-');
    const t2 = [hour, minute, second].map(formatNumber).join(':');

    return `${t1} ${t2}`
}

export function inAppBrowser() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i)) {
        return 'wx';
    } else if (ua.match(/QQ/i)) {
        return 'QQ';
    } else if (ua.match(/Alipay/i)) {
        return 'alipay';
    }
    return false;
}

export function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function getExtName(fileName) {
    let pos = fileName.lastIndexOf('.');
    return pos < 0 ? '' : fileName.substring(pos + 1);
}

export function pageIsFinish(responseBody) {
    return responseBody.page >= Math.ceil(responseBody.total / responseBody.pageSize);
}

export function getUrlRelativePath(url) {
    let arrUrl = url.split('//');
    let relUrl = arrUrl[1].substring(arrUrl[1].indexOf('/'));
    if (relUrl.indexOf('?') !== -1) {
        relUrl = relUrl.split('?')[0];
    }
    return relUrl;
}

export function loadScript(urls) {
    const promiseList = [];
    urls.forEach((item) => {
        const p = new Promise((resolve, reject) => {
            const script = document.createElement('script')
            script.type = 'text/javascript';
            script.src = item;
            script.onload = () => {
                script.onload = null;
                script.onerror = null;
                resolve();
            };
            script.onerror = () => {
                script.onload = null;
                script.onerror = null;
                reject();
            };
            const head = document.getElementsByTagName('head')[0];
            (head || document.body).appendChild(script);
        })
        promiseList.push(p);
    });
    return Promise.all(promiseList);
}